<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (isHamburgerVisible$ | async) {
      <button type="button" mat-button class="hamburger-button" (click)="toggleLeftPanel()">
        <mat-icon class="white-icon">menu</mat-icon>
      </button>
    }
    <ng-content />
  </mat-toolbar-row>
</mat-toolbar>
